import { useForm } from "react-hook-form"
import { Paper, Table, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from "@mui/material"
import { useMemo, useState } from "react"
import { useQuery } from "react-query"
import moment from "moment"
import debounce from "../../utilis/methods/networkHandling"
import CustomTableBody from "../../utilis/component/CustomTableBody"
import { FormOnChangeEventType } from "../../EMR/types"
import { CustomFormField } from "../../utilis/component/CustomFormElement"
import { getRadiologyListService } from "./Services"
import { getRadioPayloadType, RadiologyLandingListType } from "./Type"
import { useNavigate } from "react-router-dom"
import { base } from "../../constants"
import moduleRoutes from "../../routes/moduleRouteList"
import dashboardRouteList from "../routeList"
// import useAuthentication from "@hooks/useAuthentication"
const RadiologyLandingPage = () => {
    const {control}=useForm()
    const navigate=useNavigate()
    const [searchPayload, setSearchPayload] = useState<getRadioPayloadType>({
        clinicId: 1,
        searchText: "",
        searchDate: moment().format("YYYY-MM-DD"), 
        pageNumber: 0,
        pageSize: 25,
        sortField: "",
        sortOrder: "asc",
      })
      // const {mutate:getRadiologyList,data:RadiologyList,isLoading}=useMutation(getRadiologyListService)
      const {
        data: RadiologyList,
        isLoading,
      } = useQuery(["getLabSearch",searchPayload],()=>getRadiologyListService(searchPayload),{
        refetchOnWindowFocus: false,
      });

      const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const pageSize = parseInt(event.target.value, 10)
        setSearchPayload((prev)=>({
            ...prev,
            pageNumber:0,
            pageSize
        }));
      };
      const handleChangePage = (_: unknown, pageNumber: number) => {
        setSearchPayload({
            ...searchPayload,
            pageNumber
        });
      };
     const searchOnText =  debounce((e:FormOnChangeEventType) => {
      setSearchPayload(prev=>({
        ...prev,
       searchText:e.target.value,
      }))
      }, 500)
    const searchByDate =  (e:FormOnChangeEventType) => {
     setSearchPayload(prev=>({
       ...prev,
      searchDate:moment(e.target.value).format("YYYY-MM-DD"),
     }))
   }

   const radiologyPatientList = useMemo(()=>{
     if(RadiologyList?.items?.length){
         return RadiologyList?.items?.reverse()
     }else{
      return []
     }
  },[RadiologyList?.items])


  // const{user}= useAuthentication();
  // const regionValue= user?.region;
  //   const idHeading =
  // regionValue === "QATAR_REGION"
  //   ? "Qatar ID"
  //   : "Emirates Id";
const idHeading = "Civil ID"
  const headings=[
    "Sl No",
    "EMR No/Reg No",
    "Patient Name",
    idHeading,
    "Mobile No",
    "Status",
]

  return (
         <div className="px-3 pt-4">
            <Paper className="flex flex-col gap-2">
              <TableContainer className=" relative ">
                <div className="px-4 py-2 border-b">
                  <Typography variant="h6">Radiology Patients</Typography>
                </div>
                <form className="py-4 px-2 grid grid-cols-4 gap-2">
                  <CustomFormField
                    control={control}
                    element="datepicker"
                    fieldProps={{ label: "Search date" }}
                    name="searchDate"
                    rules={{ required: false, onChange:searchByDate }}
                  />
                  <CustomFormField
                    control={control}
                    element="input"
                    fieldProps={{ label: "Search name" }}
                    name="searchText"
                    rules={{ required: false, onChange:searchOnText }}
                  />
                </form>
                <Table size="small" aria-label="simple table" className="border-b">
                  <TableHead
                    sx={(theme) => ({
                      backgroundColor: theme.palette.primary.main,
                    })}
                    className="sticky w-full top-0 bg-inherit z-50"
                  >
                    <TableRow>
                      {headings.map((title, index) =>
                        <TableCell
                          key={`radiolist${index}`}
                          align="center"
                          sx={(theme) => ({
                            color: theme.palette.background.paper,
                            fontWeight: 600,
                            fontSize: 14,
                          })}
                        >
                          {title}
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <CustomTableBody
                    alert={"No records"}
                    dataLoading={isLoading}
                    isData={Boolean(RadiologyList?.items?.length) }
                    totalSpan={{ col: headings.length, row: 10 }}
                  >
                    {radiologyPatientList.map((row: RadiologyLandingListType, index:number) => (
                      <TableRow
                        onClick={() => {
                           navigate(`${base}${moduleRoutes.mainRoute}/${moduleRoutes.dashboard}/${dashboardRouteList.Radiology}/${row.encounterID}?emrno=${row?.emrNo || ""}`);
                        }}
                        className="hover:bg-gray-100"
                        key={`emrlistId${index}`}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          cursor: "pointer",
                        }}
                      >
                       <TableCell>{searchPayload.pageNumber * searchPayload.pageSize + (index + 1)}</TableCell>
                        <TableCell align="center">{row.emrNo}</TableCell>
                        <TableCell align="center">{row.firstName}</TableCell>
                        <TableCell align="center">{row.MobileNo}</TableCell>
                        <TableCell align="center">{row.emiratesId}</TableCell>
                        <TableCell align="center">
                        {row.isPerformed ? (
                                row.isCashed?<span  className="text-green-600 font-bold">Completed</span>:
                                 <span className="text-yellow-600 font-bold">
                                   Performed — <span className="text-red-400 font-bold">( Not Paid)</span>
                                   </span>
                               ) : (
                                 <span className="text-red-400 font-bold">Not Performed<span className={row.isCashed?"text-green-400 font-bold":"text-red-400 font-bold"}>({row.isCashed ? "Paid" : "Not Paid"})</span></span>
                               )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </CustomTableBody>
                </Table>
              </TableContainer>
              <div >
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={RadiologyList?.totalCount || 0}
                  rowsPerPage={searchPayload.pageSize}
                  page={searchPayload.pageNumber}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            </Paper>
          </div>
  )
}
export default RadiologyLandingPage


